import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { REDIRECT_AFTER_MS } from "../../constants";
import { useFormContext } from "../context/FormContext";
import { FF2EventName, trackFF2Event } from "../analytics";
import { Spinner } from "../../../Spinner";

export const RedirectToRateTracker: React.FC = () => {
  const { formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.REDIRECT_REMO_HOLDING_PAGE, formData);

    setTimeout(() => {
      navigate("/ff2-remortgage");
    }, REDIRECT_AFTER_MS);
  }, []);

  return (
    <div className="heroff2-form">
      <h2>Thank you.</h2>
      <h2>
        You will receive an email about your next steps shortly. Redirecting in
        {" "}
        {REDIRECT_AFTER_MS / 1000}
        {" "}
        seconds...
      </h2>
      <Spinner />
    </div>
  );
};
